import React from 'react';
import ShowArticleStockAmountProperties from "./ShowArticleStockAmountProperties";
import {useStyles} from "./ShowArticleStockAmount.style";
import clsx from "clsx";
import { useUserContext } from '../../../contexts/UserContext';
import Access from '../../Access/AllowAccess/Access';

const ShowArticleStockAmount: React.FC<ShowArticleStockAmountProperties> = ({
                                                      physicalAmount,
                                                      bookAmount,
                                                      className = '',
                                                  }) => {

    const classes = useStyles();
    const userStore = useUserContext();

    if (!userStore.hasAccess(Access.GET_ARTICLE_STOCK.valueOf())) {
        return <></>
    }

    const physicalValue = physicalAmount ?? 0;
    const bookValue = bookAmount ?? 0;

    return (
        <div className={clsx(classes.show_price_container, className)}>
            {/* Existencia Física */}
            <div className={clsx(
                classes.stock_item,
                physicalValue >= 0 ? classes.stock_item_positive : classes.stock_item_negative
            )}>
                <div className={classes.label_container}>
                    <div className={classes.title}>Existencia Física</div>
                </div>
                <div className={classes.value_container}>
                    <div className={clsx(
                        classes.number,
                        physicalValue >= 0 && classes.positive,
                        physicalValue < 0 && classes.negative,
                    )}>{physicalValue}</div>
                </div>
            </div>

            {/* Artículos en Faltante */}
            <div className={clsx(
                classes.stock_item,
                bookValue >= 0 ? classes.stock_item_positive : classes.stock_item_negative
            )}>
                <div className={classes.label_container}>
                    <div className={classes.title}>Artículos en Faltante</div>
                </div>
                <div className={classes.value_container}>
                    <div className={clsx(
                        classes.number,
                        bookValue >= 0 && classes.positive,
                        bookValue < 0 && classes.negative,
                    )}>{bookValue}</div>
                </div>
            </div>
        </div>
    )
}


export default ShowArticleStockAmount;